import React from "react";
import { Check, X } from "lucide-react";

const YES_ITEMS = [
  "You want $1 Jell-O shots and zero pretense",
  "You like talking to strangers at the bar",
  "You're killing time before/after an Astros game",
  "You'd rather play pool than scroll your phone",
  "You appreciate a sticky floor as a personality trait",
];

const NO_ITEMS = [
  "You're looking for a craft cocktail program",
  "You need a full food menu (we don't have one)",
  "You want quiet, polished, or upscale",
  "Crowded, loud rooms aren't your thing",
];

const SectionHeader = () => (
  <div className="text-center mb-16">
    <div className="font-mono-plex text-[11px] tracking-[0.3em] uppercase text-[#FFB800] flex items-center justify-center gap-3">
      <span className="h-px w-8 bg-[#FFB800]" />
      06 — Quick Gut Check
      <span className="h-px w-8 bg-[#FFB800]" />
    </div>
    <h2 className="mt-4 font-display text-5xl md:text-7xl leading-[0.95] text-[#F5F2E6]">
      IS SUNNY<span className="text-[#FF2A2A]">'</span>S{" "}
      <span className="text-stroke-red">FOR YOU?</span>
    </h2>
  </div>
);

const FitCard = ({
  testid,
  title,
  items,
  Icon,
  accent,
  borderClass,
  textClass,
  iconClass,
}) => (
  <div
    data-testid={testid}
    className={`grain-card relative bg-[#121212] border ${borderClass} p-7 md:p-10`}
  >
    <div className="flex items-center gap-3 mb-6">
      <div
        className={`w-10 h-10 flex items-center justify-center ${iconClass}`}
      >
        <Icon size={22} strokeWidth={3} className="text-current" />
      </div>
      <div className={`font-display text-3xl md:text-4xl ${textClass}`}>
        {title}
      </div>
    </div>
    <ul className="space-y-4">
      {items.map((t) => (
        <li key={t} className="flex items-start gap-3">
          <Icon
            size={18}
            strokeWidth={2.5}
            className={`${accent} mt-1 shrink-0`}
          />
          <span className={`${textClass} text-base md:text-lg leading-snug`}>
            {t}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

const FitCheck = () => {
  return (
    <section
      data-testid="fit-check"
      className="relative px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-[#0A0A0A]"
    >
      <SectionHeader />
      <div className="grid md:grid-cols-2 gap-4 md:gap-6">
        <FitCard
          testid="fit-yes"
          title="YOU'LL LOVE IT IF…"
          items={YES_ITEMS}
          Icon={Check}
          accent="text-[#FF2A2A]"
          borderClass="border-[#FF2A2A]/40"
          textClass="text-[#F5F2E6]"
          iconClass="bg-[#FF2A2A] text-white"
        />
        <FitCard
          testid="fit-no"
          title="MAYBE SKIP IT IF…"
          items={NO_ITEMS}
          Icon={X}
          accent="text-[#A3A3A3]"
          borderClass="border-[#262626]"
          textClass="text-[#A3A3A3]"
          iconClass="border border-[#A3A3A3] text-[#A3A3A3]"
        />
      </div>
    </section>
  );
};

export default FitCheck;
